<template>
  <div class="span2 np" :id="`somm_flags_${therapy.id}`">
    <xLabel v-if="therapiesXpEnabled && !therapy.infusion && (therapy.drug_id == null || therapy.prontuario == false)"></xLabel>
    <pLabel v-if="therapy.personale"></pLabel>
    <nsLabel v-if="therapy.non_sostituibile"></nsLabel>
    <fdLabel v-if="therapy.fuori_dispenser"></fdLabel>
    <npLabel
      v-if="therapiesPreparationEnabled && !therapy.fuori_dispenser && !therapy.al_bisogno"
      :done-preparation="therapy.preparation_done"
      :notes="therapy.preparation_notes"
    >
    </npLabel>
    <olLabel v-if="therapy.off_label"></olLabel>
    <ptLabel v-if="therapy.piano_terapeutico"></ptLabel>
    <rmLabel v-if="therapy.richiesta_motivata"></rmLabel>
    <asLabel v-if="therapy.autosomm"></asLabel>
  </div>
</template>
<script>
import asLabel from '../tagLabels/asLabel';
import fdLabel from '../tagLabels/fdLabel';
import npLabel from '../tagLabels/npLabel';
import nsLabel from '../tagLabels/nsLabel';
import olLabel from '../tagLabels/olLabel';
import pLabel from '../tagLabels/pLabel';
import xLabel from '../tagLabels/xLabel';
import ptLabel from '../tagLabels/ptLabel';
import rmLabel from '../tagLabels/rmLabel';
export default {
  name: 'drugTagLabel',
  props: ['therapy', 'therapiesPreparationEnabled', 'therapiesXpEnabled'],
  components: {
    asLabel,
    fdLabel,
    npLabel,
    nsLabel,
    olLabel,
    pLabel,
    xLabel,
    ptLabel,
    rmLabel,
  },
  methods: {},
};
</script>
